import { Subject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { SgClickConfirmPlugins, SgClickConfirmPluginContext } from './types';

@Injectable()
export class SgConfirmClickRef<T = any, D = any> {
  public style: keyof SgClickConfirmPlugins;
  public data?: D;
  readonly closed: Observable<T>;
  private _close: Subject<T>;

  private constructor() {
    this._close = new Subject<T>();
    this.closed = this._close.asObservable();
  }

  close(value: T): void {
    if (this._close.closed) {
      throw new Error('Closed.');
    } else {
      this._close.next(value);
      this._close.complete();
    }
  }

  static create<T = any, D = any>(
    style: keyof SgClickConfirmPlugins,
    ctx: SgClickConfirmPluginContext
  ): SgConfirmClickRef<T, D> {
    const ref = new SgConfirmClickRef<T, D>();
    ref.style = style;
    ref.data = ctx.options.data;
    return ref;
  }
}
